import React from 'react';
import _ from 'lodash';
import { FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

import { InfoField } from './InfoField';
import { useDidMountEffect, useDynamicFunction } from '../../services/hooks/';
import { handleDynamicFunction, handleShowOn } from '../../services/functions';
import { RequiredField } from '../others/RequiredField';

export const RadioChoiceField = props => {
  const { field, formik, getFieldCallback, params, events, sections, formIdentifier, hideFieldsCallback, metaData } = props;
  const dynamicFunction = useDynamicFunction(field.on_change);
  const handleChange = val => {
    formik.setFieldTouched(field.name, true);
    if (!_.isNil(dynamicFunction)) {
      const res = handleDynamicFunction(dynamicFunction, formik, field, val);
      if (res.callback) {
        props[res.callback](res.data, field.options.indexOf(val));
      }
    } else {
      formik.setFieldValue(field.name, val);
    }
  };

  React.useEffect(() => {
    if (field.name == 'canoeing_activities') {
      formik.setFieldValue('canoeing_activities', '');
    }
  }, []);

  React.useEffect(() => {
    const pesel = formik.values.participant_pesel;
    if (pesel && pesel.length === 11) { // tylko pełny PESEL
      const genderDigit = parseInt(pesel[9], 10);
      const gender = genderDigit % 2 === 0 ? 'Dziewczynka ' : 'Chłopiec ';
      // ustawiamy wartość w Formik tylko jeśli jest różna
      if (formik.values.participant_gender !== gender) {
        formik.setFieldValue('participant_gender', gender);
      }
    }
  }, [formik.values.participant_pesel]); // efekt wywołuje się przy zmianie PESEL

  useDidMountEffect(() => {
    // Dla lata KDR pokazujemy tylko gdy pozostałe promocje nie są wybrane
    if (formIdentifier == 'lato' && field.name == 'has_big_family_card') {
      const toHideFields = [];
      const toShowFields = [];
      let showKDR = true;
      let showSP = false;
      if (formik.values.quick_payment_promotion == true) {
        showKDR = false;
      }
      if (formik.values.seasonal_promotion) {
        showKDR = false;
        showSP = true;
      }
      if (formik.values.discount_code_promotions.length > 0) {
        showKDR = false;
      }
      if (Array.isArray(formik.values.ol_discounts) && formik.values.ol_discounts[0]) {
        showKDR = false;
      }
      if (showKDR) {
        toShowFields.push('has_big_family_card');
      } else {
        toHideFields.push('has_big_family_card');
      }
      if (showSP) {
        toShowFields.push('seasonal_promotion');
      } else {
        toHideFields.push('seasonal_promotion');
      }
      hideFieldsCallback(toHideFields, toShowFields, null, [], []);
    // Dla wyjazdow rodzinnych KDR pokazujemy, gdy łączy się z wybranymi promocjami
    } else if (formIdentifier == 'wyjazdy_rodzinne' && field.name == 'has_big_family_card') {
      const toHideFields = [];
      const toShowFields = [];
      let showKDR = true;
      if (Array.isArray(formik.values.ol_discounts)) {
        const selectedPromotions = metaData.promotions.filter(p => formik.values.ol_discounts.includes(p.id));
        const promotionsNotConnectedWithKDR = selectedPromotions.find(sp => sp.is_connected_with_big_family_card === false);
        if (promotionsNotConnectedWithKDR) {
          showKDR = false;
        }
      }
      if (showKDR) {
        toShowFields.push('has_big_family_card');
      } else {
        toHideFields.push('has_big_family_card');
      }
      hideFieldsCallback(toHideFields, toShowFields, null, [], []);
    }


  }, [formik.values.quick_payment_promotion, formik.values.discount_code_promotions, formik.values.seasonal_promotion, formik.values.ol_discounts]);

  // Warunek dla statusu klienta w formularzu lato 2026
  if (field.name == 'client_status' && 'resort' in params && events && (!sections[1].fields[0].dynamicOptions || sections[1].fields[0].dynamicOptions.length == 0)) {
    return null;
  }

  const formikError =
  formik.touched[field.name] && Boolean(formik.errors[field.name]);

  return (
    <FormControl error={formikError} style={{ display: field.hide ? 'none' : handleShowOn(
      field.show_on, formik.values,
      getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []))
      ? ''
      : 'none', marginTop: field.name == 'canoeing_activities' ? 10 : 0, marginBottom: 10 }}>
      <Typography variant="subtitle1" >
        <b>{field.label}</b>
        { field.label
          ? <RequiredField required={field.required} isEmpty={_.isEmpty(formik.values[field.name])} formikError={formik.touched[field.name] && Boolean(formik.errors[field.name])} />
          : null}
      </Typography>
      <RadioGroup
        row
        value={formik.values[field.name] || ''}
        onChange={e => handleChange(e.target.value)
        }
      >
        { !_.isNil(formik.values[field.name])
          ? _.map(field.options, (name, key) => (
            <FormControlLabel
              value={name}
              key={key}
              control={<Radio />}
              label={name} />
          ))
          : null}
      </RadioGroup>
      {formikError && (
        <Typography variant="caption" color="error">
          {formik.errors[field.name]}
        </Typography>
      )}
      {
        !_.isEmpty(field.infos)
          ? _.map(field.infos, (info, key) => <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />)
          : null
      }
    </FormControl>
  );
};
